<template></template>

<script>
export default {};
</script>

<style lang="sass" scoped>

</style>